import { useSuspenseQuery } from '@w/react-query'
import { SidebarGroup, SidebarGroupLabel, SidebarGroupContent, SidebarMenu, SidebarMenuItem, SidebarMenuButton } from '@w/ui/components/sidebar'
import { DatabaseIcon } from '@w/ui/components/icon'
import { useNavigate } from '../router/flashcards-fe.router-bindings'
import type { SpaceResource } from '../router/spaces-resources'
import { databasesOptions } from './database-space'

/**
 * The space's existing databases, the only way back to one: databases are tables, not pages, so the page tree cannot
 * list them. Creation lives in the editor's / menu (flashcards-editor-home.requirements.md 2026-11-02); the list
 * renders nothing while the space has no database.
 */
export function DatabaseSidebar({ resource }: { resource: SpaceResource }) {
  const navigate = useNavigate()
  const { data: tables } = useSuspenseQuery(databasesOptions(resource), resource.queryClient)
  if (tables.length === 0) return null
  function open(table: string) { navigate({ to: '/$workspaceId/spaces/$spaceId/databases/$table', params: { workspaceId: resource.space.workspaceId, spaceId: resource.space.id, table } }) }
  return <SidebarGroup className="py-0" data-testid="flashcards-databases">
    <SidebarGroupLabel className="mb-0! min-w-0 justify-start gap-2 px-2">
      <DatabaseIcon className="size-3.5 shrink-0" />
      <span className="truncate">Databases</span>
    </SidebarGroupLabel>
    <SidebarGroupContent>
      <SidebarMenu className="gap-0.5">
        {tables.map(table => <SidebarMenuItem key={table.name}>
          <SidebarMenuButton className="rounded-lg px-1.5" size="sm" data-testid={`flashcards-database-link-${table.name}`} onClick={() => { open(table.name) }}>
            <DatabaseIcon />
            <span>{table.name}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>)}
      </SidebarMenu>
    </SidebarGroupContent>
  </SidebarGroup>
}
